import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root',
})
export class QBuiltSharedInspService {
  private serialSearchList = new BehaviorSubject<any[]>(null);
  serialSearchList$ = this.serialSearchList.asObservable();

  private currentTabList = new BehaviorSubject<any[]>(null);
  currentTabList$ = this.currentTabList.asObservable();

  private currentDataList = new BehaviorSubject<any[]>(null);
  currentDataList$ = this.currentDataList.asObservable();

  private defectFormGroup = new BehaviorSubject<any>(null);
  defectFormGroup$ = this.defectFormGroup.asObservable();

  private currentDefectList = new BehaviorSubject<any[]>(null);
  currentDefectList$ = this.currentDefectList.asObservable();

  private currentOpenDefectList = new BehaviorSubject<any[]>(null);
  currentOpenDefectList$ = this.currentOpenDefectList.asObservable();

  setCurrentOpenDefectList(list: any[]) {
    this.currentOpenDefectList.next(list);
  }

  getCurrentOpenDefectList() {
    return this.currentOpenDefectList.getValue();
  }

  setCurrentDefectList(list: any[]) {
    this.currentDefectList.next(list);
  }

  getCurrentDefectList() {
    return this.currentDefectList.getValue();
  }

  setDefectFormGroup(formGroup: any) {
    this.defectFormGroup.next(formGroup);
  }

  getDefectFormGroup() {
    return this.defectFormGroup.getValue();
  }

  setSerialSearchList(list: any[]) {
    this.serialSearchList.next(list);
  }

  getSerialSearchList() {
    return this.serialSearchList.getValue();
  }

  setCurrentTabList(list: any[]) {
    this.currentTabList.next(list);
  }

  getCurrentTabList() {
    return this.currentTabList.getValue();
  }

  setCurrentDataList(list: any[]) {
    this.currentDataList.next(list);
  }

  getCurrentDataList() {
    return this.currentDataList.getValue();
  }
}
